import CategoryNavigation from '@/components/common/navigation/CategoryNavigation'

export { CategoryNavigation }
